import { clsModel, fnCreate } from '@cls/clsModel'

// We operate on a sales invoice, no special model name for sending an invoice. 
var modelName = "tender_accept";
const fields = ['id', 'send_confirmation', 'tend_number'];

class clsTenderAccept extends clsModel {

    id = null;
    send_confirmation = true;
    tend_number  = null;

    get subTitle() {
        return this.tend_number;
    }

    // We don't load. Just fill default values.
    async load(id, params) {
        return this.fill(params);
    }

    /**
     * Instead of saving, we just return the data
     */
    async save() {
        let data = this.toJSON();
        return data;
    }

    fill(data) {
        data = data || {};
        data.send_confirmation = true;
        return super.fill(data);
    }
    
    constructor() {
        super({
          modelName: modelName, 
          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsTenderAccept, 'clsTenderAccept');
